import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-image-text',
    templateUrl: './block-image-text.component.html',
})

export class BlockImageTextComponent extends BlockAbstractComponent implements OnInit {

}
